export default __webpack_public_path__ + "static/platform_back-57bf39fc02c932a6c18a3f079c412aeb.webp";